import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumbers from "../../../helpers/numbers";
import allAskTransaction from "./AllTransaction";
import StatusAskTransaction from "./StatusAskTransaction";

export default function AllAskTransaction() {
  return (
    <>
      <Sidebar openItem="finance" activeItem="all-ask-transaction" />

      <div className="content-wrapper">
        <TitleBar title="درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="pb-2">
                <Link
                  to="/finance/ask-transaction/add"
                  className="btn btn-success"
                >
                  <span className="pl-2">
                    <i className="fa fa-plus"> </i>
                  </span>
                  <span>درخواست انتقال وجه جدید</span>
                </Link>
              </div>
              <div className="table-responsive pt-2">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره درخواست</td>
                      <td>مبلغ</td>
                      <td>نام مالک حساب</td>
                      <td>نام بانک</td>
                      <td>وضعیت</td>
                      <td>تاریخ ارسال درخواست</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {allAskTransaction.map((item, index) => {
                      let classBadgeStatePage;
                      switch (item.status) {
                        case StatusAskTransaction.getStatusAskTransactionString()[
                          StatusAskTransaction.statusAskTransaction.PENDING
                        ]:
                          classBadgeStatePage = "badge-warning";
                          break;
                        case StatusAskTransaction.getStatusAskTransactionString()[
                          StatusAskTransaction.statusAskTransaction.PAID
                        ]:
                          classBadgeStatePage = "badge-info";
                          break;
                        case StatusAskTransaction.getStatusAskTransactionString()[
                          StatusAskTransaction.statusAskTransaction.REJECT
                        ]:
                          classBadgeStatePage = "badge-danger";
                          break;
                      }
                      return (
                        <tr>
                          <td>{helperNumbers.toPersianNum(index + 1)}</td>
                          <td>{helperNumbers.toPersianNum(item.id)}</td>
                          <td className="letter-spacing-finance-number">
                            {helperNumbers.toPersianNum(
                              helperNumbers.toFormatFinanceNumber(item.price)
                            )}
                          </td>
                          <td>{item.owner_account_name}</td>
                          <td>{item.bank_name}</td>
                          <td>
                            <span className={`badge ${classBadgeStatePage}`}>
                              {item.status}
                            </span>{" "}
                          </td>
                          <td>{item.created_at}</td>
                          <td>
                            <Link
                              to={`/finance/ask-transaction/info/${item.id}`}
                              className="btn btn-info"
                            >
                              <i className="fa fa-info"></i>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
